export class GeoApi {
    client;
    constructor(client) {
        this.client = client;
    }
    geocode(input) {
        return this.client.request({ method: 'POST', path: '/v1/geo/geocode', body: input, auth: true });
    }
    reverseGeocode(input) {
        return this.client.request({ method: 'POST', path: '/v1/geo/reverse-geocode', body: input, auth: true });
    }
    route(input) {
        return this.client.request({ method: 'POST', path: '/v1/geo/route', body: input, auth: true });
    }
    /**
     * D671: address type-ahead. The server answers from the shared places base first (the rider's own saved and recent places, then the city's places) and
     * only reaches an external provider when the base is thin, so a keystroke normally costs no external call. `degraded` means the provider fallback was
     * wanted but could not run - show the local list anyway. Errors: 400 `SUGGEST_QUERY_REQUIRED` / `SUGGEST_QUERY_TOO_LONG` / `SUGGEST_NEAR_INVALID` /
     * `SUGGEST_LIMIT_INVALID` / `SUGGEST_MARKET_INVALID`; 429 `GEOCODE_USER_LIMIT` (only when nothing local was found); 503 `PLACES_UNAVAILABLE`.
     */
    suggestPlaces(input) {
        const params = new URLSearchParams({ market: input.market, q: input.q });
        if (input.near !== undefined)
            params.set('near', `${input.near.latitude},${input.near.longitude}`);
        if (input.limit !== undefined)
            params.set('limit', String(input.limit));
        if (input.sessionToken !== undefined)
            params.set('sessionToken', input.sessionToken);
        return this.client.request({ method: 'GET', path: `/v1/geo/places/suggest?${params.toString()}`, auth: true });
    }
    /**
     * D847: close a type-ahead session with the chosen prediction: its point and address (stored in the shared places base). Errors: 400
     * `PLACE_DETAILS_INVALID`, 404 `GEOCODE_NOT_FOUND`, 429 `GEO_USER_DAILY_CAP` / `GEO_USER_LIMIT`, 503 `PLACES_UNAVAILABLE`.
     */
    placeDetails(input) {
        return this.client.request({ method: 'POST', path: '/v1/geo/places/details', body: input, auth: true });
    }
    /** D847: what the app applies itself for a market (the type-ahead debounce, the device-label switch, the autocomplete mode). */
    clientRules(market) {
        return this.client.request({ method: 'GET', path: `/v1/geo/client-rules?market=${encodeURIComponent(market)}`, auth: true });
    }
    /** D436: the postal-code format of a market's country (label, mask, length); 404 `POSTAL_CODE_UNSUPPORTED` when none. */
    postalCodeFormat(market) {
        return this.client.request({ method: 'GET', path: `/v1/geo/postal-code/format?market=${encodeURIComponent(market)}`, auth: true });
    }
    /** D793: how the market's country writes an address line (the apps show its short form); `rule: null` when its pack declares none (show the line as it came). */
    addressDisplayRule(market) {
        return this.client.request({ method: 'GET', path: `/v1/geo/address-display?market=${encodeURIComponent(market)}`, auth: true });
    }
    /** D436: resolve a postal code to its thoroughfare / neighbourhood / locality (the person then adds the number). */
    lookupPostalCode(input) {
        return this.client.request({ method: 'GET', path: `/v1/geo/postal-code?market=${encodeURIComponent(input.market)}&code=${encodeURIComponent(input.code)}`, auth: true });
    }
    compareRoute(input) {
        return this.client.request({ method: 'POST', path: '/v1/geo/route/compare', body: input, auth: true });
    }
    attribution(market) {
        return this.client.request({
            method: 'GET',
            path: `/v1/geo/maps/attribution?market=${encodeURIComponent(market)}`,
            auth: true,
        });
    }
}
//# sourceMappingURL=geo.js.map